export const configs = {
    localApiUrl: "https://lhdapi.usertesting123.co.uk/api",
    // localApiUrl:"http://localhost:6001/api",
}